<template>
  <div class="memlist-search-select">
    <label v-if="title" class="ml-text-label">
      {{ title }}
      <span v-if="required" class="required-asterisk">*</span>
    </label>

    <div class="dropdown-wrapper" @click="toggleDropdown">
      <div class="selected-value" :class="{ disabled }">
        {{ selectedText || placeholder }}
      </div>
      <div v-show="dropdownOpen" class="dropdown-list">
        <memlist-text-input
          ref="searchInput"
          v-model="searchText"
          placeholder="Sök..."
          class="search-box"
        />
        <div v-if="filteredItems.length > 0" class="options-list">
          <div
            v-for="item in filteredItems"
            :key="item.value"
            class="dropdown-item"
            @click.stop="selectItem(item)"
          >
            {{ item.text }}
          </div>
        </div>
        <div v-else class="no-results">Inga resultat</div>
      </div>
    </div>

    <div class="error-text" v-if="required && !value && localValidated === false">
      {{ invalid_text }}
    </div>
    <div class="info-text" v-if="info_text">{{ info_text }}</div>
  </div>
</template>

<script>
export default {
  name: 'MemlistSearchSelect',
  props: {
    value: [String, Number, null],
    items: {
      type: Array,
      default: () => [],
    },
    title: String,
    placeholder: {
      type: String,
      default: 'Välj...',
    },
    required: Boolean,
    disabled: Boolean,
    invalid_text: String,
    info_text: String,
  },
  data() {
    return {
      searchText: '',
      dropdownOpen: false,
      localValidated: null,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside, true);
  },
  computed: {
    filteredItems() {
      if (!this.items) {
        return [];
      }

      return this.items.filter(i =>
        (i.text || '').toLowerCase().includes((this.searchText || '').toLowerCase())
      );
    },
    selectedText() {
      const selected = this.items.find(i => i.value === this.value);
      return selected ? selected.text : '';
    },
  },
  watch: {
    dropdownOpen(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.searchInput?.$el?.querySelector('input')?.focus();
        });
      }
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) return;
      this.dropdownOpen = !this.dropdownOpen;
    },

    selectItem(item) {
      this.$emit('input', item.value);
      this.searchText = '';
      this.dropdownOpen = false;
      this.localValidated = true;
    },

    handleClickOutside(event) {
      // Only close if the click is truly outside the root element
      if (this.dropdownOpen && !this.$el.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
  }
};
</script>

<style scoped>
.memlist-search-select {
  position: relative;
  width: 100%;
  font-size: 13px;
}

.ml-text-label {
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 6px;
  display: block;
}

.dropdown-wrapper {
  border: 1px solid #ccc;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  padding: 8px 12px;
  position: relative;
}

.selected-value {
  color: #333;
}

.selected-value.disabled {
  color: #aaa;
  cursor: not-allowed;
}

.dropdown-list {
  position: absolute;
  width: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  max-height: none;
  overflow: visible;
}

.search-box {
  padding: 6px 12px;
  border-bottom: 1px solid #eee;
}

.options-list {
  max-height: 180px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.no-results {
  padding: 12px;
  color: #888;
  font-style: italic;
}

.error-text {
  color: #fd397a;
  font-style: italic;
  margin-top: 6px;
}

.info-text {
  color: #6c757d;
  font-size: 12px;
  margin-top: 4px;
}

.required-asterisk {
  color: #00c900;
  margin-left: 2px;
}
</style>
